<script>
/* global axios */
// Diálogo de encaminhar mensagem: escolhe inbox + contato (telefone/email) e
// envia o conteúdo numa nova conversa. Independe de provedor.
import { mapGetters } from 'vuex';
import { useAlert } from 'dashboard/composables';
import NextButton from 'dashboard/components-next/button/Button.vue';

export default {
  components: { NextButton },
  props: {
    message: { type: Object, required: true },
  },
  emits: ['close'],
  data() {
    return {
      selectedInboxIds: [],
      identifier: '',
      content: '',
      saving: false,
    };
  },
  computed: {
    ...mapGetters({
      inboxes: 'inboxes/getInboxes',
      accountId: 'getCurrentAccountId',
    }),
  },
  async mounted() {
    this.content = this.message?.content || '';
    // garante que a lista de caixas está carregada (senão fica vazia)
    if (!this.inboxes.length) {
      try {
        await this.$store.dispatch('inboxes/get');
      } catch (e) {
        // mantém o que tiver
      }
    }
  },
  methods: {
    toggleInbox(id) {
      const i = this.selectedInboxIds.indexOf(id);
      if (i === -1) this.selectedInboxIds.push(id);
      else this.selectedInboxIds.splice(i, 1);
    },
    async submit() {
      if (
        !this.selectedInboxIds.length ||
        !this.identifier.trim() ||
        !this.content.trim()
      )
        return;
      this.saving = true;
      try {
        const { data } = await axios.post(
          `/api/v1/accounts/${this.accountId}/kanban/forward_messages`,
          {
            inbox_ids: this.selectedInboxIds,
            contact_identifier: this.identifier.trim(),
            content: this.content.trim(),
          }
        );
        useAlert(
          this.$t('CONVERSATION.FORWARD.SUCCESS', {
            forwarded: data.forwarded,
            total: data.total,
          })
        );
        this.$emit('close');
      } catch (e) {
        useAlert(e?.response?.data?.error || this.$t('CONVERSATION.FORWARD.ERROR'));
      } finally {
        this.saving = false;
      }
    },
  },
};
</script>

<template>
  <div
    class="fixed inset-0 z-[9999] flex items-center justify-center p-4 bg-n-alpha-black2"
    @click.self="$emit('close')"
  >
    <div class="w-[28rem] max-w-full p-6 bg-n-background rounded-xl shadow-xl">
      <h2 class="mb-4 text-base font-medium text-n-slate-12">
        {{ $t('CONVERSATION.FORWARD.TITLE') }}
      </h2>
      <label class="block mb-1 text-sm font-medium text-n-slate-12">{{
        $t('CONVERSATION.FORWARD.INBOX')
      }}</label>
      <div
        class="mb-3 max-h-40 overflow-y-auto border rounded-lg border-n-weak divide-y divide-n-weak"
      >
        <label
          v-for="ib in inboxes"
          :key="ib.id"
          class="flex items-center gap-2 px-3 py-2 text-sm cursor-pointer text-n-slate-12 hover:bg-n-alpha-1"
        >
          <input
            type="checkbox"
            :checked="selectedInboxIds.includes(ib.id)"
            @change="toggleInbox(ib.id)"
          />
          {{ ib.name }}
        </label>
        <p v-if="!inboxes.length" class="px-3 py-2 text-xs text-n-slate-10">
          —
        </p>
      </div>
      <label class="block mb-1 text-sm font-medium text-n-slate-12">{{
        $t('CONVERSATION.FORWARD.CONTACT')
      }}</label>
      <input
        v-model="identifier"
        :placeholder="$t('CONVERSATION.FORWARD.CONTACT_PLACEHOLDER')"
        class="w-full px-3 py-2 mb-3 text-sm border rounded-lg border-n-weak bg-n-alpha-1 text-n-slate-12"
      />
      <label class="block mb-1 text-sm font-medium text-n-slate-12">{{
        $t('CONVERSATION.FORWARD.MESSAGE')
      }}</label>
      <textarea
        v-model="content"
        rows="4"
        class="w-full px-3 py-2 text-sm border rounded-lg resize-none border-n-weak bg-n-alpha-1 text-n-slate-12"
      />
      <div class="flex justify-end gap-2 mt-4">
        <NextButton
          slate
          faded
          sm
          :label="$t('CONVERSATION.FORWARD.CANCEL')"
          @click="$emit('close')"
        />
        <NextButton
          blue
          sm
          :is-loading="saving"
          :label="$t('CONVERSATION.FORWARD.SUBMIT')"
          @click="submit"
        />
      </div>
    </div>
  </div>
</template>
